module.exports = __webpack_public_path__ + "img/1 (62).d4678ded.png";